export class CarPark {
  constructor ({ id = null, name = '', image = null, telegram_channel = null, telegramChannel = null } = {}) {
    this.id = id
    this.name = name
    this.image = image
    this.telegramChannel = telegram_channel || telegramChannel // telegramChannel for self frontend in carParkPermissions initialization
  }

  backendModel () {
    return {
      telegram_channel: this.telegramChannel,
      image: this.image,
      name: this.name,
      id: this.id,
    }
  }
}
